import { Component } from '@angular/core';
import { LegalLayoutComponent } from '../components/legal-layout.component';

@Component({
  selector: 'app-privacidad',
  standalone: true,
  imports: [LegalLayoutComponent],
  templateUrl: './privacidad.component.html',
  styleUrl: './privacidad.component.css'
})
export class PrivacidadComponent {
  title = 'Política de Privacidad';
  lastUpdated = '30 de octubre de 2025';
}

